export default __webpack_public_path__ + "static/media/great_job_high_five.b8936306.svg";